/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RequestBookingAccountEmailChangePayload } from 'api/actions/request-booking-account-email-change/request-booking-account-email-change-payload';
import { RequestBookingAccountEmailChangePathParameters } from 'api/actions/request-booking-account-email-change/request-booking-account-email-change-path-parameters';
import { RequestBookingAccountEmailChangeResponse } from 'api/actions/request-booking-account-email-change/request-booking-account-email-change-response';

type RequestBookingAccountEmailChangeQueryParameters = Record<string, any>;

/**
 * The path of the RequestBookingAccountEmailChange action.
 */
export const requestBookingAccountEmailChangeActionPath = new SweetPath<
  keyof RequestBookingAccountEmailChangePathParameters
>('/reservations/account/email-change/request', { path: '{param}' });

/**
 * Creates a contextualized RequestBookingAccountEmailChange actions.
 */
export default function createRequestBookingAccountEmailChangeAction(axios: AxiosInstance) {
  return function requestBookingAccountEmailChangeAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: RequestBookingAccountEmailChangeQueryParameters;
    payload: RequestBookingAccountEmailChangePayload;
  }) {
    const path = requestBookingAccountEmailChangeActionPath.original;

    return axios.post<
      RequestBookingAccountEmailChangeResponse,
      RequestBookingAccountEmailChangeResponse,
      RequestBookingAccountEmailChangePayload
    >(path, payload);
  };
}
